import { Button, Result } from "antd";

function SomethingWentWrong() {
  return (
    <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center" }}>
      <Result
        status="error"
        title="Something went wrong"
        subTitle="This page failed to load. Please refresh and try again."
        extra={
          <Button type="primary" onClick={() => window.location.assign(window.location.href)}>
            Refresh
          </Button>
        }
      />
    </div>
  );
}

export default SomethingWentWrong;
